module.exports = __webpack_public_path__ + "static/android_5_EN-62e50d182fa361712d53e30906a55848.jpg";